module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-ja-JP.c89aa210.jpg";